module.exports = __webpack_public_path__ + "img/15.7178851a.png";